export const CREATE_PRODUCT_SIZE = 'CREATE_PRODUCT_SIZE'
export const GET_LIST_PRODUCT_SIZE = 'GET_LIST_PRODUCT_SIZE'
export const DETAIL_PRODUCT_SIZE = 'DETAIL_PRODUCT_SIZE'
export const PATCH_PRODUCT_SIZE = 'PATCH_PRODUCT_SIZE'
